import React from 'react';
import styles from './VerifyInfo.module.css';
import { Row } from 'reactstrap';
import { ContractContext } from '../contexts/ContractContext';
import classNames from 'classnames';
import getClientContent from '../_BrandingProvider/brandContent.jsx';
import { useLocation } from 'react-router-dom';
import { ReactComponent as CheckmarkIcon } from '../../assets/images/checkmark.svg';

const StepsHeader = ({ active, children, fulfillmentTypeId, showHireOwnServicer }) => {
    const StepStatus = ({ num, stepStyle }) => {
        if (active > num) {
            return (
                <div>
                    <span className={stepStyle}>
                        <CheckmarkIcon className={classNames('circle', styles.iconStyle)} />
                    </span>
                </div>
            );
        } else {
            return (
                <div>
                    <span className={stepStyle}>
                        <span className='circlePoint'></span>
                    </span>
                </div>
            );
        }
    };

    const { state } = useLocation();
    return (
        <ContractContext.Consumer>
            {(context) => {
                const {
                    contract,
                    contract: { clientId }
                } = context.data;

                const deductible = parseInt(state?.entitlementDetails?.deductible ?? 0);
                return (
                    <>
                        <div className={styles.pageHeader}>
                            <Row className='progressBar'>
                                <div className={`progressStep ${active === 1 && 'active'}`}>
                                    <span className='pageTxt'>Incident</span>
                                    <StepStatus
                                        num={1}
                                        stepStyle='circle'
                                    />
                                </div>
                                {fulfillmentTypeId !== 3 && deductible > 0 && (
                                    <div className={`progressStep ${active === 2 && 'active'}`}>
                                        <span className='pageTxt'>Payment</span>
                                        <StepStatus
                                            num={2}
                                            stepStyle='circle'
                                        />
                                    </div>
                                )}
                                <div className={`progressStep ${active === 3 && 'active'}`}>
                                    <span className='pageTxt'>Solution</span>
                                    <StepStatus
                                        active={active}
                                        num={3}
                                        stepStyle='circle last'
                                    />
                                </div>
                            </Row>
                            {active === 1 && (
                                <h1 className={classNames('h1', styles.pageTitle)}>Tell Us What Happened</h1>
                            )}
                            {active === 2 && (
                                <h1 className={classNames('h1', styles.pageTitle)}>
                                    {`Pay Your ${getClientContent(clientId).variableText.planDetails.paymentType}`}
                                </h1>
                            )}
                            {active === 3
                                && (fulfillmentTypeId === 3 && showHireOwnServicer ? (
                                    <h1 className={classNames('h1', styles.pageTitle)}>Hire Your Own Servicer</h1>
                                ) : fulfillmentTypeId === 2 ? (
                                    <h1 className={classNames('h1', styles.pageTitle)}>Let's Talk Replacement</h1>
                                ) : (
                                    <h1 className={classNames('h1', styles.pageTitle)}>Let's Schedule Service</h1>
                                ))}
                        </div>
                        <section>{children}</section>
                    </>
                );
            }}
        </ContractContext.Consumer>
    );
};

export default StepsHeader;
